module.exports = __webpack_public_path__ + "static/media/Tax+Link.d8158554.png";